<template>
  <div>
    <div
      class="market-body"
      v-if="isMainPage"
      :style="{
        height: bodyHeight,
        background:
          'url(' + data.rule.backImage + ') no-repeat center center /cover'
      }"
    >
      <!-- <div class="market-body" v-if="isMainPage"> -->
      <div class="rules" @click="handleOpenRule">
        规则
      </div>
      <div
        class="rules orders"
        v-if="isHasOrder"
        @click="handleOpenOrderDetail"
      >
        订单
      </div>
      <div class="account" v-if="userInfo">
        <div>
          <van-image
            round
            width="14px"
            height="14px"
            :src="accountAvatar[loginType]"
          />
          <div v-if="userInfo" :title="userInfo.nick_name">
            账号:{{ userInfo.nick_name && getNick_name(userInfo.nick_name) }}
          </div>
          <!-- <div>{{ loginType === 'phoneDynameic' ? '手机号': '账号'}}:{{ loginType === 'phoneDynameic' ? userInfo.mobile: userInfo && userInfo.nick_name }}</div> -->
        </div>
        <div @click="login">切换</div>
      </div>
      <div
        class="product-packages"
        :style="{ paddingTop: data.detail.productSpace + 'rem' }"
      >
        <template v-for="(item, i) in data.detail.productInfoList">
          <div
            :key="i"
            @click="handleGoBuy(item)"
            :class="{
              scanLayoutStyle: true,
              layoutStyle1: currentLayoutStyle === 1,
              layoutStyle2: currentLayoutStyle === 2,
              layoutStyle3: currentLayoutStyle === 3
            }"
          >
            <van-image
              width="width:100%;"
              :src="productImage(item.androidImage, item.iosImage)"
            />
            <!-- <img width="width:100%;" :src="productImage(item.androidImage, item.iosImage)" /> -->
          </div>
        </template>
      </div>
      <van-popup position="bottom" round closeable v-model="showRule">
        <div
          class="rule-content"
          v-html="data.rule && data.rule.activeExplain"
        ></div>
      </van-popup>
    </div>
    <template v-else>
      <van-loading size="24px">正在跳转中...</van-loading>
    </template>
    <van-popup class="popup" v-model="showTip">
      <div style="text-align:center; margin-top:20px;">温馨提示</div>
      <div class="showTip" v-html="showTipText"></div>
      <van-button
        type="primary"
        v-if="isIOSSystem"
        v-clipboard:copy="data.detail.shortUrl"
        v-clipboard:success="onCopy"
        >复制链接</van-button
      >
      <van-button v-else type="danger" @click="showTip = false"
        >知道了</van-button
      >
    </van-popup>
    <div class="footer" v-if="data.rule.countDownSwitch">
      <span>{{ countDownTimeText }}&nbsp;&nbsp;</span
      ><van-count-down
        v-if="isShowCountDown"
        @finish="handleCountTime"
        :time="countDownTime"
      >
        <template #default="timeData">
          <span class="block">{{ timeData.days }}天&nbsp;</span>
          <span class="block">{{ timeData.hours }}时&nbsp;</span>
          <span class="block">{{ timeData.minutes }}分&nbsp;</span>
          <span class="block">{{ timeData.seconds }}秒</span>
        </template>
      </van-count-down>
    </div>
    <van-popup position="bottom" round closeable v-model="isGroup">
      <div class="group-content">
        <div class="title">
          <span v-if="group.takePart > 0">{{ group.takePart }}</span
          >{{
            group.takePart === 0
              ? '还没有人开团，赶紧抢占沙发!'
              : '个小伙伴正在拼，点拼单即可参与'
          }}
        </div>
        <div class="time" v-if="countDownTimeText !== ''">
          <van-count-down :time="countDownTime">
            <template #default="timeData">
              <span class="block">剩余&nbsp;{{ timeData.days }}天&nbsp;</span>
              <span class="block">{{ timeData.hours }}时&nbsp;</span>
              <span class="block">{{ timeData.minutes }}分&nbsp;</span>
              <span class="block">{{ timeData.seconds }}秒</span>
            </template>
          </van-count-down>
        </div>
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          class="list-content"
        >
          <div class="list" v-for="(item, i) in group.list" :key="i + 'g'">
            <div>
              <div>
                <img :src="item.avatar" />
                <!-- <van-image
                         round
                        :src="item.avatar"
                      /> -->
              </div>
              <div class="name">{{ item.nickName }}</div>
            </div>
            <div>
              <div>
                还差<span>{{ item.residue }}</span
                >人拼成
              </div>
              <div class="btns">
                <van-button round type="primary" @click="goPay(item.groupId)"
                  >拼单</van-button
                >
              </div>
            </div>
          </div>
        </van-list>
        <div class="footer-btns" v-if="currentPackage">
          <div @click="handleSingleBuy">
            原价购买￥{{ currentPackage.productPrice }}
          </div>
          <div @click="goPay(0)">我要开团￥{{ group.groupPrice }}</div>
        </div>
      </div>
    </van-popup>
    <van-popup class="redEnvelopeImage" round v-model="redEnvelopeSwitch">
      <img
        :src="data.rule.redEnvelopeImage"
        @click="redEnvelopeSwitch = false"
      />
      <!-- <van-image
            :src="data.rule.redEnvelopeImage"
            @click="redEnvelopeSwitch=false"
          /> -->
      <span>{{ data.rule.redEnvelopeContent }}</span>
    </van-popup>
  </div>
</template>
<script>
import Vue from 'vue'
import { List, Toast } from 'vant'
import wx from '../weixin'
Vue.use(Toast)
Vue.use(List)
export default {
  components: {
    // PaySuccess
  },
  data () {
    return {
      loading: false,
      finished: false,
      group: {
        groupPrice: undefined,
        takePart: 0,
        list: [],
        total: 0
      },
      isGroup: false,
      pagination: {
        pageSize: 10,
        page: 1
      },
      currentPackage: undefined,
      redEnvelopeSwitch: false,
      // loginCheck: true,
      bodyHeight: '100vh',
      countDownTime: '',
      countDownTimeText: '',
      isShowCountDown: false,
      // countDownText: '', // 倒计时
      showTip: false,
      showTipText: '',
      isIOSSystem: false,
      orderStatus: 1, // 1为成功，2为失败
      ruleId: undefined,
      linkCode: undefined,
      currentLayoutStyle: 3,
      isHasOrder: false,
      showRule: false,
      userInfo: JSON.parse(localStorage.getItem('userinfo')),
      loginType: localStorage.getItem('loginType'),
      isMainPage: true,
      accountAvatar: {
        weixin: require('@/assets/images/scrmMarket/weixin.png'),
        qq: require('@/assets/images/scrmMarket/qq.png'),
        phoneDynameic: require('@/assets/images/scrmMarket/iphone.png')
      },
      data: {
        detail: {},
        rule: {}
      },
      chooseAccount: require('@/assets/images/sellCard/chooseAccount.png')
    }
  },
  watch: {
    isGroup: 'clearListData'
  },
  methods: {
    clearListData (n, o) {
      if (!n) {
        this.group.list = []
        this.pagination.page = 1
      }
    },
    onCopy () {
      this.showTip = false
      Toast('复制成功')
    },
    handleSingleBuy () {
      Toast('暂不支持手机上购买，您可到电视上购买哦')
    },
    productImage (androidImage, iosImage) {
      if (this.isIOS()) {
        return !iosImage ? androidImage : iosImage
      } else {
        return androidImage
      }
    },
    onLoad () {
      const p = {
        linkCode: this.linkCode,
        productCode: this.currentPackage.productCode,
        ruleId: this.ruleId,
        ...this.pagination
      }
      this.$service.getGroupList(p).then(data => {
        this.loading = false
        this.isGroup = true
        this.group.groupPrice = data.price
        this.group.takePart = data.takePart
        this.group.list = this.group.list.concat(data.pageData.list)
        this.group.total = data.pageData.total
        const { page, pageSize } = this.pagination
        // console.log('总数', page * pageSize >= data.pageData.total)
        if (page * pageSize >= data.pageData.total) {
          this.finished = true
        } else {
          this.pagination.page++
        }
      })
    },
    getNick_name (name) {
      return name.length > 10 ? name.substring(0, 10) + '...' : name
    },
    setShareActivityData () {
      const { webExplain, webTitle, shortUrl } = this.data.detail
      const shareData = {
        title: webTitle,
        desc: webExplain,
        link: shortUrl,
        imgUrl: this.data.rule.coverImage,
        success: res => {
          // console.log('home: 分享成功')
        }
      }
      wx.setShareData(shareData)
    },
    getBrowser () {
      const userAgent = window.navigator.userAgent
      if (/MicroMessenger/.test(userAgent)) {
        return 'weixin'
      } else if (/AlipayClient/.test(userAgent)) {
        return 'alipay'
      } else {
        return 'other'
      }
    },
    isIOS () {
      var u = navigator.userAgent
      // var app = navigator.appVersion
      // var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // g
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
      // console.log('isIOS', isIOS)
      return isIOS
    },
    login () {
      localStorage.setItem('go-pay', true)
      this.$constants.onLogin(
        'account,weixin,qq,phoneDynameic',
        window.location.href + '&redirect=paySuccess'
      )
    },
    goPay (groupId) {
      const item = this.currentPackage
      if (groupId !== undefined) {
        this.$constants.log({
          name: 'scrm_web_button_clicked',
          data: {
            package_id: item.productId,
            page_name: '拼单页面',
            button_name: groupId === 0 ? '【我要开团】按钮' : '【拼单】按钮'
          }
        })
      }
      if (item.isTencent) {
        if (!['weixin', 'qq'].includes(this.loginType) && !!this.loginType) {
          Toast('腾讯会员请使用微信或QQ账号登录购买')
          return
        }
      }
      const userinfo = localStorage.getItem('userinfo')
      const p = {
        linkCode: this.linkCode,
        productCode: item.productCode,
        ruleId: this.ruleId,
        isIOS: this.isIOS(),
        groupId
      }
      if (!userinfo) {
        // this.status = '去登陆'
        localStorage.setItem('pay-params', JSON.stringify(p))
        localStorage.setItem('go-pay', true)
        this.$constants.onLogin(
          item.isTencent ? 'weixin,qq' : 'account,weixin,qq,phoneDynameic',
          window.location.href + '&redirect=paySuccess'
        )
      } else {
        console.log('buyGoods 参数', p)
        this.$service.buyGoods(p).then(data => {
          window.location.href = data
        })
      }
    },
    // 处理拼团模式和普通模式
    handlePattern () {
      if (this.data.rule.marketType === 2) {
        // this.isGroup = true
        // this.isGroup = true
        this.onLoad()
      } else {
        this.goPay()
      }
    },
    handleGoBuy (item) {
      this.$constants.log({
        name: 'scrm_web_button_clicked',
        data: { package_id: item.productId, page_name: '活动主页面' }
      })
      const currentTime = new Date().getTime()
      if (!this.data.rule.enableStatus) {
        this.showTip = true
        this.showTipText = '活动已结束，下次早点来哦'
        return
      }
      if (
        new Date(this.data.rule.startTime.replace(/-/g, '/')).getTime() >
        currentTime
      ) {
        this.showTip = true
        this.showTipText = '活动未开始，耐心等待'
        return
      } else {
        if (
          new Date(this.data.rule.endTime.replace(/-/g, '/')).getTime() <
          currentTime
        ) {
          this.showTip = true
          this.showTipText = '活动已结束，下次早点来哦'
          return
        }
      }
      // 暂时屏蔽
      if (this.isIOS() && this.getBrowser() === 'weixin') {
        this.showTip = true
        this.isIOSSystem = true
        this.showTipText = this.data.rule.iosExplain
        return
      }
      if (this.currentPackage) {
        if (item.id !== this.currentPackage.id) {
          this.currentPackage = item
          this.group.list = []
          this.pagination.page = 1
        }
        this.handlePattern()
      } else {
        this.currentPackage = item
        this.handlePattern()
      }
    },
    handleOpenRule () {
      this.showRule = true
    },
    handleOpenOrderDetail () {
      this.$router.push({
        name: 'scrmPay',
        query: { ruleId: this.ruleId, linkCode: this.linkCode }
      })
    },
    handleCountTime () {
      const currentTime = new Date().getTime()
      const startTime = new Date(
        this.data.rule.startTime.replace(/-/g, '/')
      ).getTime()
      const endTime = new Date(
        this.data.rule.endTime.replace(/-/g, '/')
      ).getTime()
      if (startTime > currentTime) {
        this.countDownTime = startTime - currentTime
        this.countDownTimeText = '距离活动开始还有 '
        this.isShowCountDown = true
      } else {
        if (endTime > currentTime) {
          this.countDownTime = endTime - currentTime
          this.countDownTimeText = '限时活动 距离结束剩余 '
          this.isShowCountDown = true
        } else {
          this.countDownTime = ''
          this.isShowCountDown = false
          this.countDownTimeText = '活动已结束，下次再来'
        }
      }
    },
    getPromotionRule () {
      return Promise.resolve(
        this.$service
          .getPromotionRule({ ruleId: this.ruleId, linkCode: this.linkCode })
          .then(data => {
            data.detail.productSpace = data.detail.productSpace / 37.5
            this.data = data
            localStorage.setItem('marketData', JSON.stringify(data))
            var img = new Image()
            img.src = data.rule.backImage
            // redEnvelopeSwitch
            if (data.rule.redEnvelopeSwitch) {
              if (!localStorage.getItem('redEnvelope' + data.rule.id)) {
                this.redEnvelopeSwitch = true
                localStorage.setItem('redEnvelope' + data.rule.id, true)
              }
            }
            let htmlwidth =
              document.documentElement.clientWidth || document.body.clientWidth
            // 判断是否有缓存
            if (img.complete) {
              this.bodyHeight = img.height / (img.width / htmlwidth) + 60 + 'px'
              // console.log('bodyHeight', this.bodyHeight)
            } else {
              img.onload = () => {
                this.bodyHeight =
                  img.height / (img.width / htmlwidth) + 60 + 'px'
                // console.log('bodyHeight1', this.bodyHeight)
              }
            }
            this.setShareActivityData()
            document.title = data.detail.webTitle
            this.currentLayoutStyle = data.detail.layoutStyle
            if (!data.rule.enableStatus) {
              this.countDownTime = ''
              this.countDownTimeText = '活动已结束，下次再来'
              this.isShowCountDown = false
              return
            }
            this.handleCountTime()
          })
      )
    },
    getUserOrder () {
      this.$service
        .getUserOrder({ ruleId: this.ruleId, linkCode: this.linkCode })
        .then(data => {
          console.log('进入')
          this.isHasOrder = !!data.orderTitle
        })
    }
    // buriedPoint () {
    //   const userInfo = JSON.parse(localStorage.getItem('userinfo'))
    //   if (userInfo) {
    //     this.$constants.log({
    //       name: 'wx_nickname',
    //       chinaName: '打开首页的微信昵称'
    //     })
    //   }
    //   this.$constants.log({ name: 'page_show', chinaName: '首页的曝光' })
    // }
  },
  created () {
    this.$constants.log({
      name: 'scrm_web_page_show',
      data: { page_name: '活动主页面' }
    })
    Toast.setDefaultOptions({ duration: 5000 })
    wx.init()
    this.ruleId = this.$constants.getUrlCode('ruleId')
    this.linkCode = this.$constants.getUrlCode('linkCode')
    if (!this.ruleId || !this.linkCode) {
      Toast('地址栏没有传参数')
      return
    }
    this.getUserOrder()
    const redirect = this.$constants.getUrlCode('redirect')
    const goPay = JSON.parse(localStorage.getItem('go-pay'))
    localStorage.setItem('go-pay', null)
    this.getPromotionRule().then(() => {
      if (redirect === 'paySuccess' && goPay !== null) {
        Toast({
          message: '登录成功，确认账号后再继续购买哦',
          position: 'bottom'
        })
      }
    })
  }
}
</script>
<style lang="stylus" scoped>
.redEnvelopeImage
  >>>img
    width 300px
  background-color transparent
  span
    position: absolute;
    left: 110px;
    top: 100px;
    overflow-wrap: break-word;
    color: #fd9978;
    font-size: 60px;
    font-family: PingFangSC-Semibold;
    white-space: nowrap;
    text-align: center;
    background-image: linear-gradient(180deg, #fd9978 0%, #f31a3d 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
.group-content
   position relative
   padding 40px 15px 60px
   .footer-btns
     position fixed
     bottom 0px
     display flex
     height 50px
     line-height 50px
     left 0px
     width 100%
     color white
     font-size 16px
     >div:first-child
       width 40%
       text-align center
       background: linear-gradient(315deg, #767676 0%, #9A9FA6 100%);
     >div:last-child
       width 60%
       text-align center
       background: linear-gradient(135deg, #FF8600 0%, #FD4E00 100%);
   .title
     font-size 18px
     text-align center
   .time
     font-size 16px
     text-align center
     margin-top 10px
     >>>.van-count-down
        color #E08E00
   .list-content
      max-height 140px
      overflow auto
      .list
        display flex
        justify-content: space-between;
        align-items center
        padding 5px 0px
        .btns
          display flex
          align-items center
        >div:last-child
          >>>.van-button
            width 70px
            height 37px
            background-color #FCB232
            border 1px solid rgba(248, 187, 108, 1)
            font-size 16px
            margin-left 10px
          >div:first-child
            color #999
            font-size 14px
            span
              color rgba(248, 187, 108, 1)
              margin 0 5px
              font-weight: bolder
        >div
          display flex
          align-items center
          .name
            color #333
            font-weight: 500
            font-size 16px
            margin-left 10px
          >>>img
            width 40px
            height 40px
            border-radius 40px
.loginCheck
  position absolute
  color white
  bottom 50px
  right 50px
  background: rgba(1,1,1,0.7);
  border-radius 8px
  padding 15px
  font-size 16px
.popup
   border-radius 15px
   padding-bottom 50px
   width: 80%;
   >>>.van-button
    width: 150px;
    height: 35px;
    display: flex;
    bottom: 20px;
    position: absolute;
    border-radius: 25px;
    border: none;
    left: 50%;
    margin-left: -75px;
    display: flex;
    background-color rgba(255, 215, 28, 1)
    color black
    justify-content: center;
.footer
  position: fixed;
  display flex
  align-items: center;
  justify-content: center;
  bottom: 0px;
  background-color: black;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: white;
  font-size: 14px;
  width: 100%;
  >>>.van-count-down
    color white
.showTip
  padding 20px
  font-size 16px
.account
  display: flex;
  font-size: 12px;
  background: rgba(1,1,1,0.3);
  padding 0 10px
  justify-content: space-between;
  height: 26px;
  border-radius: 13px;
  color: white;
  position: absolute;
  top: 10px;
  left 10px
  max-width: 230px;
  min-width: 120px
  z-index 100
  align-items: center;
  >div:first-child
    display: flex;
    align-items: center;
    >div:last-child
      margin-left 5px
      margin-right 5px
.rule-content
  font-size 16px
  padding 50px 20px 20px
.market-body
  height 100vh
.rules
  background: rgba(51, 51, 51, 1)
  background: rgba(1,1,1,0.3);
  border-top-left-radius 8px
  border-bottom-left-radius 8px
  height 30px
  line-height 30px
  text-align center
  width 50px
  position absolute
  right 0px
  top 10px
  font-size 14px
  color white
  z-index 100
.rules.orders
  top 60px
.product-packages
    width 100%
    display: flex;
    flex-wrap: wrap;
    position: relative;
    left: 50%;
    margin-left: -50%;
    justify-content: space-between;
    padding-top 200px
    .scanLayoutStyle
      position relative
      text-align: center;
      margin-bottom 10px
      border-radius 16px
      font-size 16px
      width 50%
      display inline-flex
      justify-content: center;
      align-items: center;
    .layoutStyle
      display flex
      height 100px
    .layoutStyle1
      width 100%
    .layoutStyle3:first-child
      display flex
      width 100%
</style>
